import { Alert, AlertTitle, Box } from '@mui/material';
import { useSelector } from "react-redux";

export default function RegisterSubprogramCard({ subprogram }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    return (
        <>
            {(subprogram.pointsLimitReached || subprogram.subscriptionsLimitReached) && (

                <Alert severity="warning" sx={{ alignItems: "center" }}>
                    <AlertTitle>{subprogram.subprogramName}</AlertTitle>
                    <Box>
                        {subprogram.pointsLimitReached && resourceFinal[appLanguage].messages.LIMIT_POINTS}
                    </Box>
                    <Box>
                        {subprogram.subscriptionsLimitReached && resourceFinal[appLanguage].messages.LIMIT_SUBSCRIPTIONS}
                    </Box>
                </Alert>
            )}
        </>
    );
}
